// @flow

import styled, { css, keyframes } from 'styled-components';
import { zIndexMap } from '../../helpers';
import type { Theme } from '../../types';

type Props = {
  isLoading: boolean,
};

const grow = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

const StyledLoader = styled<any, Theme, Props>('span')`
  z-index: ${zIndexMap.loader};
  position: fixed;
  top: 0;
  left: 0;
  width: ${props => (props.isLoading ? '100%' : '0')};
  height: ${props => props.theme.loader.height};
  background: ${props => props.theme.loader.color};
  ${props => props.isLoading && css`
    animation: ${grow} 1.0s linear;
  `}
`;

export default StyledLoader;
